import type { ErrorDefinition } from './types';

/**
 * Network-related error definitions for connectivity issues.
 */
export const NETWORK_ERRORS: Record<string, ErrorDefinition> = {
  network_offline: {
    title: 'No internet connection',
    message:
      "It looks like you're offline. We need an internet connection to sign you in.",
    action: 'Please check your Wi-Fi or mobile data and try again.',
    retryable: true,
    category: 'network',
    recoverySuggestions: [
      'Turn on Wi-Fi or mobile data',
      'Move closer to your router',
      'Try toggling airplane mode on and off',
    ],
  },

  network_timeout: {
    title: 'Connection timed out',
    message:
      "We couldn't reach our servers. Your connection might be slow or unstable.",
    action: 'Please check your internet and try again.',
    retryable: true,
    retryAfterSeconds: 3,
    category: 'network',
    recoverySuggestions: [
      'Check your internet connection',
      'Try moving to a location with better signal',
      'Wait a moment and try again',
    ],
  },

  network_error: {
    title: 'Connection problem',
    message: 'We had trouble connecting to our servers.',
    action: 'Please check your internet connection and try again.',
    retryable: true,
    category: 'network',
  },

  server_unavailable: {
    title: 'Service unavailable',
    message:
      "Our servers are temporarily unavailable. We're working to fix this.",
    action: 'Please try again in a few minutes.',
    retryable: true,
    retryAfterSeconds: 30,
    category: 'server',
  },
};
